import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { createRoot } from 'react-dom/client'
import App from './containers/App/App'
import './index.css'
import { initializeAppInsights } from './services/AppInsights'
import { reportErrorToConsole, setupTracking } from './services/error-logger'
import { I18nextProvider } from 'react-i18next'
import i18n, { initializeI18N } from '@if/core/i18n'

const ai = initializeAppInsights()
setupTracking(ai)

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, 
      refetchOnWindowFocus: false, 
    },
  },
});

const container = document.getElementById('root')
const root = createRoot(container!)

initializeI18N()
  .then(() => { 
root.render(
  <I18nextProvider i18n={i18n}>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </I18nextProvider>,
)
}) .catch(reportErrorToConsole)
